import { Box, Button, Stack, Typography } from "@mui/material";
import GoogleIcon from "components/icons/GoogleIcon";
import { Link } from "react-router-dom";

export const styleObj = {
  ssoBtn: {
    textTransform: "none",
    maxWidth: 400,
    borderRadius: 2.5,
  },
  emailBtn: {
    background: "#0D94DB",
    borderRadius: "40px",
    color: "#fff",
    textTransform: "none",
    width: "240px",
  },
  textLink: {
    color: "#1976D2",
    cursor: "pointer",
    fontWeight: 600,
  },
};

type LoginSectionProps = {
  isSignUpActive: boolean;
  inviteId?: string;
  toggleSignupHandler: () => void;
  attemptLoginWithGoogle: () => void;
  showFormField: () => void;
};

const LoginSection = ({
  isSignUpActive,
  inviteId,
  toggleSignupHandler,
  attemptLoginWithGoogle,
  showFormField,
}: LoginSectionProps) => {
  const getUrlWithInvite = (baseUrl: string) =>
    inviteId ? `${baseUrl}?inviteId=${inviteId}` : baseUrl;

  const linkContent = isSignUpActive
    ? { text: "Have an account?", actionText: "Login now", url: "/" }
    : { text: "Need an account?", actionText: "Create one", url: "/signup" };

  return (
    <Stack>
      <Stack gap={8} padding={4} alignItems="center">
        <Button
          endIcon={<GoogleIcon sx={{ padding: 0.75 }} />}
          variant="outlined"
          size="large"
          fullWidth
          sx={{
            ...styleObj.ssoBtn,
            borderColor: "#858585",
            color: "#494949",
            fontWeight: 500,
            "&:hover": {
              borderColor: "#6e6e6e",
              color: "#2f2f2f",
              backgroundColor: "#f2f2f2",
            },
          }}
          onClick={attemptLoginWithGoogle}
        >
          Continue with Google
        </Button>
        <Button
          variant="contained"
          size="large"
          fullWidth
          sx={{
            ...styleObj.ssoBtn,
            fontWeight: 600,
            backgroundColor: "#0D94DB",
            "&:hover": {
              backgroundColor: "#0B7FC2",
            },
          }}
          onClick={showFormField}
        >
          Continue with Email
        </Button>
      </Stack>
      <Typography sx={{ textAlign: "center", pt: 2.5 }} component="div">
        <Box
          display="flex"
          justifyContent="center"
          gap={1}
          sx={{ marginBottom: 4 }}
        >
          <Typography color="#6C6C6C" sx={{ fontSize: 18 }}>
            {linkContent.text}
          </Typography>
          <Typography
            onClick={toggleSignupHandler}
            component={Link}
            to={getUrlWithInvite(linkContent.url)}
            sx={{ ...styleObj.textLink }}
          >
            {linkContent.actionText}
          </Typography>
        </Box>
      </Typography>
    </Stack>
  );
};

export default LoginSection;
